import { BaseComponent } from './base/base.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { ContactService } from './contact.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { AltaClienteComponent } from './alta-cliente/alta-cliente.component';

@NgModule({
	declarations: [
		AppComponent,
		AltaClienteComponent,
		BaseComponent,
	],
	imports: [
		BrowserModule,
		HttpClientModule,
		AppRoutingModule,
		FormsModule,
		ReactiveFormsModule,
		RecaptchaModule,
		RecaptchaFormsModule

	],
	providers: [
		ContactService
	],
	bootstrap: [BaseComponent]
})
export class AppModule { }
